const reduceFlows = flows => flows.reduce((acc, flow) => [/* eslint-disable-next-line hubspot-dev/no-reduce-accumulator-copy */
...acc, {
  activationToggleTooltipTitle: '',
  portalId: flow.portalId,
  flowId: flow.flowId,
  flowObjectTypeId: flow.objectTypeId,
  name: flow.name,
  isEnabled: flow.isEnabled,
  recommended: false,
  triggerContent: ''
}], []);
export default reduceFlows;